import { PATH_SCORE } from "@/constants/URL";
import routerWithSidebar from "../routerWithSidebar";
export default {
  path: PATH_SCORE,
  components: routerWithSidebar(() =>
    import(/* webpackChunkName: "role" */ "@/views/score/index.vue")
  )
};
